import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import { t } from '../i18n'
import { UDV_SURFACE, udvDialogProps } from './udvSurface'

/**
 * Modal bloqueante mientras se descarga study.zip (fetch → blob).
 */
const StudyZipDownloadDlg = ({ open }) => (
  <Dialog
    open={!!open}
    disableBackdropClick
    disableEscapeKeyDown
    {...udvDialogProps}
  >
    <DialogTitle style={UDV_SURFACE.title}>{t('share.downloadingStudy')}</DialogTitle>
    <DialogContent
      style={{
        ...UDV_SURFACE.content,
        textAlign: 'center',
        paddingTop: 8,
        paddingBottom: 28,
      }}
    >
      <CircularProgress size={44} thickness={4} style={{ color: '#64b5f6' }} />
      <Typography
        variant="body2"
        style={{ ...UDV_SURFACE.muted, marginTop: 18, lineHeight: 1.45 }}
      >
        {t('share.downloadingStudyHint')}
      </Typography>
    </DialogContent>
  </Dialog>
)

export default StudyZipDownloadDlg
